import Vuex from 'vuex';
import axios from 'axios';

import createPersistedState from 'vuex-persistedstate';
import user from "@/store/modules/user";
import product from "@/store/modules/product";
import address from "@/store/modules/address";
import order from "@/store/modules/order";
import page from "@/store/modules/page";
import category from "@/store/modules/category";

const baseUrl = process.env.VUE_APP_API_URL + ""; // URL для получения данных
const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };

export default new Vuex.Store({
    modules: {
        user: user,
        product: product,
        address: address,
        order: order,
        page: page,
        category: category,
    },
    state: {
        orders: [],

        images: [],
        sizes: [],
        teams: [],
        seasons: [],
        productTypes: [],
        pageTypes: [],
        conditions: [],
        brands: [],
        colors: [],
        productColors: [],
        productImages: [],

        statuses: [],

        countries: [],

        links: {
            project: [
                {
                    header: "Кто мы",
                    name: "page-item",
                    params: {url: "about-us"}
                },
                {
                    header: "Продукты",
                    name: "products",
                    params: '',
                },
                {
                    header: "Гифт карта",
                    name: "gift-card",
                    params: '',
                }
            ],
            docs: [
                {
                    header: "Политика конфиденциальности",
                    name: "page-item",
                    params: {url: "policy"}
                },
                {
                    header: "Оферта",
                    name: "page-item",
                    params: {url: "offer"}
                },
                {
                    header: "Реквизиты",
                    name: "page-item",
                    params: {url: "details"},
                },
                {
                    header: "Доставка и оплата",
                    name: "",
                    params: {},
                },
                {
                    header: "Возврат",
                    name: "",
                    params: {},
                }
            ]
        },

        deliveryMethods: [
            {
                name: 'Yandex Delivery',
                name_ru: 'Яндекс Доставка',
                link: '#',
                icon: '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z" fill="#FC3F1D"/>\n' +
                    '<path d="M27.2 13.5999H25C20.9 13.5999 18.8 15.6999 18.8 18.6999C18.8 22.0999 20.3 23.6999 23.3 25.7999L25.8 27.4999L18.6 38.2999H13.2L19.7 28.6999C16 25.9999 13.9 23.3999 13.9 19.0999C13.9 13.5999 17.7 9.8999 25 9.8999H32.2V38.3999H27.2V13.5999Z" fill="white"/>\n' +
                    '</svg>\n',
                default: true,
                id: 'ya-delivery'
            },
            {
                name: 'CDEK',
                name_ru: 'СДЭК',
                link: '#',
                icon: '<svg width="2480" height="697" viewBox="0 0 2480 697" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M380.522 527.615H272.537C104.101 527.615 226.471 168.406 368.277 168.406H538.886C566.233 168.406 614.462 173.457 638.223 105.525L674.935 0H440.984C314.291 0 215.671 44.8065 144.409 119.983C21.3119 248.633 -20.4309 449.56 9.07807 545.679C37.1525 634.585 113.456 693.122 232.946 694.566L325.807 695.294H440.267L468.341 610.732C489.213 550.741 442.419 527.615 380.522 527.615ZM1694.94 378.729L1730.22 263.808H1353.74C1291.12 263.808 1263.04 281.154 1252.24 317.293L1216.97 432.214H1593.45C1656.08 432.214 1684.15 414.867 1694.94 378.729ZM1160.83 581.1L1125.55 696.011H1502.02C1563.93 696.011 1592.72 678.674 1603.52 642.536L1638.8 527.615H1262.32C1200.42 527.615 1172.34 544.962 1160.83 581.1ZM1782.77 115.638L1818.04 0.727468H1441.56C1378.94 0.727468 1350.86 18.0639 1340.06 54.2021L1304.79 169.123H1681.27C1743.18 169.123 1771.24 151.776 1782.77 115.638ZM1214.09 138.774C1198.26 31.8041 1141.39 0.727468 1003.18 0.727468H751.238L604.39 432.214H697.251C752.672 432.214 780.747 432.931 810.266 353.431L871.445 168.406H965.024C1044.93 168.406 1026.93 268.869 986.623 366.433C950.628 452.45 888.003 528.333 812.417 528.333H656.215C593.59 528.333 564.799 545.679 553.282 581.818L514.408 696.738H628.858L741.156 696.011C840.492 695.294 921.836 688.07 1016.86 602.054C1117.63 510.269 1234.25 274.648 1214.09 138.774ZM2479.57 0H2261.46L2056.3 218.991C2032.55 244.289 2008.07 269.587 1984.32 299.218H1982.16L2084.37 0H1906.57L1666.88 696.011H1844.67L1920.97 477.02L2000.15 409.805L2062.79 607.843C2082.21 669.279 2102.38 696.011 2145.57 696.011H2281.61L2141.97 307.169L2479.57 0Z" fill="#00B33C"/>\n' +
                    '</svg>\n',
                default: false,
                id: 'cdek'
            }
        ],

        paymentMethods: [
            {
                name: 'MIR Pay',
                name_ru: 'МИР',
                link: '#',
                icon: '<svg id="mir-pay" width="1000" height="273" viewBox="0 0 1000 273" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M0 -1.31503e-06H93.8C102.3 -1.31503e-06 127.9 -2.8 139.3 37C147.8 62.6 159.2 102.4 176.3 162.1H182C199 99.5 213.2 56.9 218.9 37C230.3 -2.8 258.7 -1.31503e-06 270.1 -1.31503e-06H358.2V273H267.2V111H261.5L213.2 273H145L96.7 111H88.2V273H0M395.2 -1.31503e-06H486.2V162H494.7L554.4 28.4C565.8 2.8 591.4 -1.31503e-06 591.4 -1.31503e-06H676.7V273H585.7V111H580L520.3 244.6C508.9 270.2 480.5 273 480.5 273H395.2M798.9 190.5V273H713.6V130.8H992.2C980.8 164.9 941 190.5 895.5 190.5" fill="#0F754E"/>\n' +
                    '<path d="M997.9 113.8C1009.2 62.6 975.1 0 901.2 0H707.9C713.6 59.7 764.8 113.7 818.8 113.7" fill="url(#paint0_linear_0_1)"/>\n' +
                    '<defs>\n' +
                    '<linearGradient id="paint0_linear_0_1" x1="963.742" y1="56.9023" x2="736.31" y2="56.9023" gradientUnits="userSpaceOnUse">\n' +
                    '<stop stop-color="#1F5CD7"/>\n' +
                    '<stop offset="1" stop-color="#02AEFF"/>\n' +
                    '</linearGradient>\n' +
                    '</defs>\n' +
                    '</svg>\n',
                default: false,
                id: 'mir-pay',
            },
            {
                name: 'Mastercard',
                name_ru: 'Мастеркард',
                link: '#',
                icon: '<svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M5.82812 1.0625H10.1594V8.84062H5.82812V1.0625Z" fill="#FF5A00"/>\n' +
                    '<path d="M6.11562 4.95311C6.11562 3.37186 6.85938 1.96874 8 1.06249C7.15938 0.403113 6.10313 0.00311279 4.94688 0.00311279C2.2125 0.00623779 0 2.21874 0 4.95311C0 7.68749 2.2125 9.89999 4.94688 9.89999C6.1 9.89999 7.15938 9.49999 8 8.84061C6.85938 7.94999 6.11562 6.53436 6.11562 4.95311Z" fill="#EB001B"/>\n' +
                    '<path d="M16 4.95312C16 7.6875 13.7875 9.9 11.0531 9.9C9.9 9.9 8.84062 9.5 8 8.84062C9.15313 7.93125 9.88437 6.53125 9.88437 4.95C9.88437 3.36875 9.14062 1.96562 8 1.05937C8.8375 0.4 9.89688 0 11.05 0C13.7875 0.00625 16 2.23125 16 4.95312Z" fill="#F79E1B"/>\n' +
                    '</svg>',
                default: false
            },
            {
                name: 'VISA',
                name_ru: 'Виза',
                link: '#',
                icon: '<svg width="16" height="6" viewBox="0 0 16 6" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M6.075 0.0875001L3.98125 5.08438H2.6125L1.58125 1.09688C1.51875 0.85 1.46562 0.7625 1.275 0.65625C0.965625 0.490625 0.45 0.33125 0 0.234375L0.03125 0.0906253H2.23125C2.5125 0.0906253 2.7625 0.278125 2.82812 0.6L3.37188 3.49063L4.71875 0.0875001H6.075ZM11.4312 3.45625C11.4375 2.1375 9.60625 2.06563 9.61875 1.475C9.62187 1.29688 9.79375 1.10625 10.1656 1.05625C10.35 1.03125 10.8625 1.0125 11.4406 1.28125L11.6687 0.221875C11.3562 0.109375 10.9563 0 10.4594 0C9.18125 0 8.28125 0.678125 8.275 1.65313C8.26562 2.37188 8.91563 2.775 9.40625 3.0125C9.90938 3.25625 10.0781 3.41563 10.0781 3.63438C10.075 3.96875 9.675 4.11875 9.30313 4.125C8.65313 4.13438 8.275 3.95 7.975 3.80937L7.74062 4.90312C8.04375 5.04062 8.6 5.1625 9.17813 5.16875C10.5375 5.16562 11.425 4.49375 11.4312 3.45625ZM14.8031 5.0875H16L14.9563 0.0906253H13.8531C13.6062 0.0906253 13.3969 0.234375 13.3031 0.45625L11.3625 5.0875H12.7188L12.9875 4.34062H14.6469L14.8031 5.0875ZM13.3625 3.31563L14.0437 1.44063L14.4344 3.31563H13.3625ZM7.92188 0.0875001L6.85313 5.08438H5.55937L6.62813 0.0875001H7.92188Z" fill="#1434CB"/>\n' +
                    '</svg>\n',
                default: false
            },
            {
                name: 'Union Pay',
                name_ru: 'Юнион Пэй',
                link: '#',
                icon: '<svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<g clip-path="url(#clip0_24672_2305)">\n' +
                    '<path d="M6.25527 0H14.2275C15.3404 0 16.0325 0.907125 15.773 2.02375L12.0613 17.9594C11.7994 19.0721 10.685 19.98 9.57152 19.98H1.5999C0.488649 19.98 -0.205101 19.0721 0.0545242 17.9594L3.76777 2.02375C4.0274 0.907125 5.14102 0 6.25527 0Z" fill="#E21836"/>\n' +
                    '<path d="M13.5641 0H22.7321C23.8447 0 23.3431 0.907125 23.0814 2.02375L19.3701 17.9594C19.1099 19.0721 19.191 19.98 18.076 19.98H8.90812C7.79312 19.98 7.10312 19.0721 7.365 17.9594L11.0759 2.02375C11.3394 0.907125 12.4508 0 13.5641 0Z" fill="#00447C"/>\n' +
                    '<path d="M22.3685 0H30.3407C31.4552 0 32.1474 0.907125 31.8857 2.02375L28.1745 17.9594C27.9126 19.0721 26.7976 19.98 25.6832 19.98H17.7147C16.5997 19.98 15.9081 19.0721 16.1694 17.9594L19.881 2.02375C20.1406 0.907125 21.2535 0 22.3685 0Z" fill="#007B84"/>\n' +
                    '<path d="M8.33724 5.10698C7.51749 5.11536 7.27537 5.10698 7.198 5.08873C7.16825 5.22998 6.615 7.78198 6.6135 7.78411C6.49437 8.30036 6.40775 8.66848 6.11325 8.90611C5.94625 9.04423 5.75112 9.11098 5.52487 9.11098C5.16137 9.11098 4.9495 8.93036 4.914 8.58798L4.90712 8.47048C4.90712 8.47048 5.01787 7.77886 5.01787 7.77498C5.01787 7.77498 5.5985 5.44936 5.7025 5.14198C5.708 5.12448 5.7095 5.11536 5.71087 5.10698C4.58075 5.11698 4.38037 5.10698 4.36662 5.08873C4.359 5.11373 4.331 5.25798 4.331 5.25798L3.73812 7.87923L3.68725 8.10148L3.58875 8.82861C3.58875 9.04423 3.63112 9.22036 3.71537 9.36923C3.9855 9.84123 4.756 9.91198 5.19187 9.91198C5.75337 9.91198 6.28025 9.79261 6.63625 9.57473C7.25412 9.20973 7.41587 8.63898 7.56 8.13173L7.62687 7.87161C7.62687 7.87161 8.225 5.45623 8.32662 5.14198C8.33037 5.12448 8.33199 5.11536 8.33724 5.10698ZM10.3722 7.05548C10.2281 7.05548 9.96474 7.09048 9.72799 7.20648C9.64212 7.25061 9.56087 7.30148 9.47512 7.35223L9.5525 7.07298L9.51012 7.02598C9.00825 7.12761 8.89587 7.14123 8.43225 7.20648L8.3935 7.23236C8.33962 7.67861 8.29175 8.01423 8.09225 8.89161C8.0158 9.21615 7.9378 9.54032 7.85825 9.86411L7.8795 9.90498C8.35475 9.87998 8.49887 9.87998 8.91187 9.88673L8.94524 9.85048C8.99774 9.58173 9.0045 9.51873 9.12075 8.97436C9.17537 8.71636 9.28925 8.14936 9.34537 7.94748C9.4485 7.89961 9.55037 7.85261 9.6475 7.85261C9.879 7.85261 9.85075 8.05448 9.84187 8.13498C9.83187 8.26998 9.74762 8.71111 9.66112 9.08986L9.60337 9.33423C9.56325 9.51486 9.51912 9.69023 9.47887 9.86923L9.49637 9.90498C9.96462 9.87998 10.1075 9.87998 10.5074 9.88673L10.5544 9.85048C10.6267 9.43073 10.6479 9.31836 10.7761 8.70723L10.8406 8.42648C10.966 7.87686 11.029 7.59823 10.9341 7.37123C10.8339 7.11686 10.5931 7.05548 10.3722 7.05548ZM12.6459 7.63086C12.3969 7.67873 12.2381 7.71048 12.0804 7.73111C11.924 7.75611 11.7714 7.77898 11.5309 7.81236L11.5117 7.82961L11.4942 7.84336C11.4692 8.02261 11.4517 8.17748 11.4185 8.35961C11.3904 8.54786 11.347 8.76186 11.2765 9.06923C11.2219 9.30448 11.1937 9.38648 11.1626 9.46923C11.1322 9.55211 11.0989 9.63261 11.0375 9.86398L11.0519 9.88536L11.0639 9.90498C11.2887 9.89436 11.4359 9.88673 11.587 9.88536C11.738 9.87998 11.8945 9.88536 12.1365 9.88661L12.1577 9.86948L12.1805 9.85036C12.2155 9.64161 12.2206 9.58548 12.242 9.48373C12.2632 9.37448 12.2997 9.22336 12.3894 8.81948C12.4317 8.62986 12.4789 8.44073 12.5229 8.24723C12.5685 8.05448 12.6162 7.86473 12.6617 7.67498L12.655 7.65211L12.6459 7.63086ZM12.6511 6.85511C12.4249 6.72161 12.028 6.76398 11.7607 6.94836C11.4944 7.12911 11.464 7.38561 11.6895 7.52086C11.9117 7.65061 12.3102 7.61198 12.5751 7.42598C12.841 7.24136 12.8742 6.98723 12.6511 6.85511ZM14.019 9.94686C14.4766 9.94686 14.9457 9.82061 15.2989 9.44648C15.5705 9.14298 15.6951 8.69136 15.7382 8.50536C15.8786 7.88898 15.7692 7.60123 15.632 7.42598C15.4232 7.15873 15.0544 7.07298 14.6717 7.07298C14.4417 7.07298 13.8937 7.09573 13.4656 7.49048C13.1581 7.77511 13.0161 8.16148 12.9305 8.53173C12.844 8.90923 12.7445 9.58848 13.3692 9.84136C13.562 9.92411 13.8399 9.94686 14.019 9.94686ZM13.9832 8.55998C14.0887 8.09323 14.2134 7.70148 14.5312 7.70148C14.7804 7.70148 14.7985 7.99298 14.6877 8.46123C14.6679 8.56523 14.577 8.95173 14.454 9.11623C14.368 9.23773 14.2665 9.31136 14.154 9.31136C14.1206 9.31136 13.9219 9.31136 13.9187 9.01623C13.9172 8.87048 13.947 8.72161 13.9832 8.55998ZM16.8821 9.88686L16.9179 9.85048C16.9686 9.58173 16.977 9.51861 17.0892 8.97448C17.1455 8.71636 17.2617 8.14948 17.3162 7.94748C17.4196 7.89948 17.5197 7.85248 17.62 7.85248C17.8499 7.85248 17.8219 8.05436 17.8127 8.13486C17.8044 8.27011 17.72 8.71098 17.632 9.08973L17.5774 9.33411C17.5356 9.51486 17.4901 9.69011 17.4499 9.86936L17.4674 9.90511C17.9374 9.88011 18.0746 9.88011 18.4769 9.88686L18.5255 9.85048C18.596 9.43048 18.6151 9.31823 18.7472 8.70723L18.8101 8.42636C18.9361 7.87673 18.9999 7.59836 18.9065 7.37136C18.8034 7.11698 18.5612 7.05561 18.3434 7.05561C18.199 7.05561 17.9342 7.09036 17.6989 7.20661C17.6147 7.25061 17.5304 7.30136 17.4476 7.35236L17.5197 7.07311L17.481 7.02586C16.9792 7.12761 16.8647 7.14123 16.4016 7.20661L16.366 7.23236C16.3099 7.67873 16.2642 8.01411 16.0647 8.89173C15.9883 9.21621 15.9103 9.54034 15.8309 9.86411L15.8521 9.90511C16.328 9.88011 16.47 9.88011 16.8821 9.88686ZM20.3344 9.90498C20.3639 9.76073 20.5394 8.90623 20.5409 8.90623C20.5409 8.90623 20.6902 8.27911 20.6995 8.25636C20.6995 8.25636 20.7465 8.19111 20.7935 8.16523H20.8626C21.5154 8.16523 22.2525 8.16523 22.8301 7.74023C23.2232 7.44873 23.492 7.01836 23.6119 6.49523C23.643 6.36698 23.6659 6.21448 23.6659 6.06198C23.6659 5.86161 23.6257 5.66336 23.5095 5.50848C23.2149 5.09636 22.6282 5.08873 21.951 5.08561L21.6172 5.08873C20.7504 5.09948 20.4027 5.09636 20.2599 5.07886C20.2479 5.14198 20.2251 5.25436 20.2251 5.25436C20.2251 5.25436 19.9146 6.69348 19.9146 6.69573L19.1365 9.89973C19.8934 9.89061 20.2037 9.89061 20.3344 9.90498ZM20.9097 7.34848C20.9097 7.34848 21.2397 5.91223 21.2382 5.91773L21.249 5.84398L21.2536 5.78798L21.3856 5.80148C21.3856 5.80148 22.0665 5.85998 22.0824 5.86148C22.3511 5.96548 22.4619 6.23348 22.3846 6.58323C22.314 6.90298 22.1067 7.17173 21.8402 7.30148C21.6209 7.41148 21.3521 7.42061 21.0752 7.42061H20.8961L20.9097 7.34848ZM22.9652 8.58661C22.878 8.95848 22.7777 9.63786 23.3994 9.87998C23.5976 9.96423 23.7752 9.98936 23.9556 9.98023C24.1464 9.96998 24.323 9.87436 24.4866 9.73673L24.4422 9.90661L24.4705 9.94286C24.9176 9.92411 25.0564 9.92411 25.5407 9.92786L25.5847 9.89436C25.6554 9.47848 25.7221 9.07473 25.906 8.27911C25.9955 7.89811 26.0849 7.52073 26.1767 7.14123L26.1624 7.09948C25.6622 7.19211 25.5286 7.21198 25.0474 7.28011L25.0109 7.30986C25.006 7.34861 25.0009 7.38573 24.9962 7.42286C24.9215 7.30198 24.813 7.19873 24.6457 7.13448C24.4317 7.05023 23.9292 7.15873 23.4974 7.55198C23.1937 7.83286 23.048 8.21761 22.9652 8.58661ZM24.0157 8.60936C24.1229 8.15086 24.2457 7.76311 24.5645 7.76311C24.766 7.76311 24.8721 7.94898 24.8505 8.26611C24.832 8.35185 24.8129 8.43743 24.793 8.52286C24.7611 8.65911 24.7266 8.79411 24.693 8.92936C24.6587 9.02186 24.6189 9.10911 24.5752 9.16723C24.4932 9.28348 24.2981 9.35548 24.1857 9.35548C24.1539 9.35548 23.9572 9.35548 23.9505 9.06548C23.9489 8.92123 23.9786 8.77261 24.0157 8.60936ZM29.5015 7.09561L29.4627 7.05148C28.9679 7.15173 28.8782 7.16773 28.4236 7.22911L28.3901 7.26248C28.3886 7.26798 28.3872 7.27623 28.3849 7.28386L28.3834 7.27636C28.0449 8.05736 28.0547 7.88886 27.7792 8.50361C27.7776 8.47561 27.7776 8.45823 27.7761 8.42848L27.7071 7.09561L27.6639 7.05148C27.1454 7.15173 27.1331 7.16773 26.6544 7.22911L26.617 7.26248C26.6117 7.27848 26.6117 7.29598 26.6086 7.31498L26.6117 7.32186C26.6716 7.62761 26.6572 7.55936 26.7172 8.04211C26.7452 8.27898 26.7826 8.51723 26.8105 8.75123C26.8577 9.14273 26.8842 9.33548 26.9419 9.93311C26.6186 10.4666 26.542 10.6686 26.2306 11.1369L26.2329 11.1415L26.0136 11.4882C25.9886 11.5247 25.9659 11.5497 25.934 11.5605C25.899 11.5777 25.8535 11.5809 25.7904 11.5809H25.6689L25.4884 12.1814L26.1077 12.192C26.4712 12.1905 26.6997 12.0205 26.8227 11.792L27.2122 11.1246H27.206L27.247 11.0776C27.509 10.5137 29.5015 7.09561 29.5015 7.09561ZM22.9652 14.9816H22.7025L23.675 11.7654H23.9975L24.1 11.4341L24.1097 11.8025C24.0977 12.0302 24.2769 12.2321 24.7475 12.1987H25.2919L25.4791 11.5795H25.2744C25.1566 11.5795 25.1019 11.5497 25.1087 11.486L25.0989 11.1111H24.091V11.1131C23.7651 11.1199 22.7919 11.1444 22.5949 11.1969C22.3565 11.2581 22.1052 11.439 22.1052 11.439L22.204 11.1072H21.2611L21.0646 11.7654L20.0792 15.0307H19.888L19.7005 15.6456H21.5784L21.5155 15.8506H22.4407L22.5022 15.6456H22.7617L22.9652 14.9816ZM22.1947 12.4189C22.0437 12.4606 21.7629 12.5874 21.7629 12.5874L22.0127 11.7654H22.7617L22.5811 12.3642C22.5811 12.3642 22.3496 12.378 22.1949 12.4189M22.2092 13.5931C22.2092 13.5931 21.974 13.6227 21.8191 13.6576C21.6666 13.7039 21.3805 13.8496 21.3805 13.8496L21.6386 12.9942H22.3915L22.2092 13.5931ZM21.7895 14.9891H21.0381L21.256 14.2672H22.005L21.7895 14.9891ZM23.5991 12.9942H24.6822L24.5266 13.4984H23.4291L23.2644 14.0494H24.2247L23.4975 15.0732C23.4466 15.1485 23.401 15.1751 23.3502 15.1962C23.2994 15.2221 23.2325 15.2525 23.1552 15.2525H22.8887L22.7057 15.856H23.4025C23.7647 15.856 23.9787 15.6912 24.1366 15.475L24.6354 14.7925L24.7424 15.4855C24.7651 15.6152 24.8584 15.6912 24.9215 15.7207C24.9912 15.7557 25.0634 15.8157 25.1652 15.8247C25.2744 15.8294 25.3532 15.8331 25.4057 15.8331H25.7482L25.9537 15.1576H25.8187C25.7412 15.1576 25.6076 15.1446 25.585 15.1204C25.5621 15.0907 25.5621 15.0454 25.55 14.9761L25.4412 14.2816H24.9965L25.1916 14.0494H26.287L26.4555 13.4984H25.4414L25.5992 12.9942H26.6104L26.7979 12.3726H23.7836L23.5991 12.9942ZM14.451 15.1295L14.7037 14.2885H15.7429L15.9326 13.663H14.8926L15.0514 13.1454H16.0676L16.256 12.5396H13.7131L13.5287 13.1454H14.1065L13.9524 13.6629H13.3731L13.1811 14.2991H13.7586L13.4216 15.4119C13.3762 15.5591 13.443 15.6152 13.4854 15.6837C13.5287 15.7504 13.5726 15.7945 13.6714 15.8195C13.7732 15.8422 13.843 15.8559 13.9377 15.8559H15.1091L15.3179 15.1629L14.7986 15.2342C14.6984 15.2342 14.4206 15.2222 14.451 15.1295ZM14.5701 11.1035L14.3069 11.5794C14.2506 11.6832 14.1997 11.7479 14.1541 11.7775C14.1139 11.8025 14.0341 11.8131 13.9187 11.8131H13.7814L13.5977 12.4219H14.054C14.2735 12.4219 14.4419 12.3415 14.5224 12.3012C14.6089 12.255 14.6316 12.2814 14.6984 12.2169L14.8525 12.0834H16.2772L16.4664 11.4496H15.4234L15.6055 11.1034L14.5701 11.1035ZM16.6735 15.1417C16.6492 15.1067 16.6667 15.0451 16.7039 14.9169L17.0932 13.628H18.4786C18.6805 13.6251 18.8261 13.6227 18.9211 13.616C19.0229 13.6052 19.1336 13.5689 19.2542 13.5036C19.3789 13.4352 19.4426 13.3631 19.4964 13.2804C19.5564 13.1979 19.6529 13.017 19.7356 12.7384L20.2251 11.1072L18.7876 11.1156C18.7876 11.1156 18.3449 11.1809 18.15 11.2531C17.9534 11.3335 17.6724 11.5581 17.6724 11.5581L17.8021 11.111H16.9141L15.6709 15.2342C15.6267 15.3942 15.5971 15.5105 15.5904 15.5804C15.5881 15.6555 15.6852 15.73 15.7482 15.7861C15.8226 15.8422 15.9326 15.8331 16.0381 15.8422C16.1491 15.8506 16.3069 15.8559 16.5247 15.8559H17.2072L17.4166 15.1485L16.8057 15.2062C16.7404 15.2062 16.6932 15.1712 16.6735 15.1417ZM17.3445 12.7575H18.7995L18.707 13.0474C18.6941 13.0541 18.663 13.033 18.5149 13.0505H17.2549L17.3445 12.7575ZM17.636 11.785H19.1034L18.9977 12.1342C18.9977 12.1342 18.3062 12.1275 18.1955 12.1479C17.708 12.2322 17.4234 12.4926 17.4234 12.4926L17.636 11.785ZM18.7397 14.0182C18.7276 14.0616 18.7085 14.088 18.682 14.1079C18.6524 14.1269 18.6045 14.1336 18.5332 14.1336H18.326L18.3382 13.7806H17.4757L17.4407 15.5067C17.4395 15.6312 17.4515 15.7034 17.5426 15.7611C17.6339 15.8331 17.9146 15.8424 18.2926 15.8424H18.833L19.028 15.1961L18.5576 15.222L18.4011 15.2311C18.3799 15.222 18.3594 15.2136 18.3366 15.191C18.3169 15.1714 18.2834 15.1834 18.2889 15.0589L18.2926 14.6164L18.7859 14.596C19.0524 14.596 19.1662 14.5092 19.2634 14.4267C19.356 14.3476 19.3864 14.2567 19.4214 14.1336L19.5041 13.7419H18.8261L18.7397 14.0182Z" fill="#FEFEFE"/>\n' +
                    '</g>\n' +
                    '<defs>\n' +
                    '<clipPath id="clip0_24672_2305">\n' +
                    '<rect width="32" height="20" fill="white"/>\n' +
                    '</clipPath>\n' +
                    '</defs>\n' +
                    '</svg>\n',
                default: false,
                id: 'union-pay',
            },
            {
                name: 'T-Bank',
                name_ru: 'Т-Банк',
                link: '#',
                icon: '<svg width="95" height="28" viewBox="0 0 95 28" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M47.2971 11.7154C46.6416 11.4632 45.7842 11.3877 44.8512 11.3877H39.6564V9.7738H48.5832V7H36V19.0031H44.5234C45.7086 19.0031 46.5909 18.9023 47.2468 18.6499C48.6337 18.1204 49.5667 16.8344 49.5667 15.1449C49.5667 13.4303 48.6841 12.245 47.2971 11.7154ZM45.4815 15.8762C45.2799 15.9519 45.0025 15.977 44.6493 15.977H39.6564V14.0605H44.6493C45.0529 14.0605 45.3806 14.0859 45.6329 14.2119C45.9354 14.3632 46.0868 14.6406 46.0868 14.9935C46.0868 15.3466 45.9103 15.7249 45.4815 15.8762Z" fill="#333333"/>\n' +
                    '<path d="M59.8189 7H54.473L49.5557 19.0031H53.6913L54.3721 17.2631H59.9197L60.6259 19.0031H64.7363L59.8189 7ZM55.2798 14.6153L57.02 9.7738H57.2973L59.0372 14.6153H55.2798Z" fill="#333333"/>\n' +
                    '<path d="M69.4424 14.5399V19.0032H65.7861V7H69.4424V11.3878H75.3179V7H78.9744V19.0032H75.3179V14.5399H69.4424Z" fill="#333333"/>\n' +
                    '<path d="M84.762 14.4643V19.0032H81.1055V7H84.762V11.5139H85.7706L90.1836 7H94.7728L88.9226 12.7494L94.9999 19.0032H90.133L85.7706 14.4643H84.762Z" fill="#333333"/>\n' +
                    '<path d="M0 0H29V13.5849C29 17.3238 27.0054 20.7789 23.7676 22.6485L14.5001 28L5.23246 22.6485C1.99457 20.7789 3.32377e-06 17.3238 3.32377e-06 13.5849L0 0Z" fill="#FFDD2D"/>\n' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M8 7V11.5077C8.6164 10.8116 9.73715 10.3406 11.0186 10.3406H12.4111V15.5807C12.4111 16.9748 12.0323 18.3399 11.4703 19.0111H17.5276C16.9668 18.3392 16.5889 16.9758 16.5889 15.5834V10.3406H17.9815C19.2629 10.3406 20.3836 10.8116 21 11.5077V7H8Z" fill="#333333"/>\n' +
                    '</svg>\n',
                default: true,
                id: 'tbank',
            }
        ],

        activePaymentMethods: [
            {
                name: 'T-Bank',
                name_ru: 'Т-Банк',
                link: '#',
                icon: '<svg width="95" height="28" viewBox="0 0 95 28" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M47.2971 11.7154C46.6416 11.4632 45.7842 11.3877 44.8512 11.3877H39.6564V9.7738H48.5832V7H36V19.0031H44.5234C45.7086 19.0031 46.5909 18.9023 47.2468 18.6499C48.6337 18.1204 49.5667 16.8344 49.5667 15.1449C49.5667 13.4303 48.6841 12.245 47.2971 11.7154ZM45.4815 15.8762C45.2799 15.9519 45.0025 15.977 44.6493 15.977H39.6564V14.0605H44.6493C45.0529 14.0605 45.3806 14.0859 45.6329 14.2119C45.9354 14.3632 46.0868 14.6406 46.0868 14.9935C46.0868 15.3466 45.9103 15.7249 45.4815 15.8762Z" fill="#333333"/>\n' +
                    '<path d="M59.8189 7H54.473L49.5557 19.0031H53.6913L54.3721 17.2631H59.9197L60.6259 19.0031H64.7363L59.8189 7ZM55.2798 14.6153L57.02 9.7738H57.2973L59.0372 14.6153H55.2798Z" fill="#333333"/>\n' +
                    '<path d="M69.4424 14.5399V19.0032H65.7861V7H69.4424V11.3878H75.3179V7H78.9744V19.0032H75.3179V14.5399H69.4424Z" fill="#333333"/>\n' +
                    '<path d="M84.762 14.4643V19.0032H81.1055V7H84.762V11.5139H85.7706L90.1836 7H94.7728L88.9226 12.7494L94.9999 19.0032H90.133L85.7706 14.4643H84.762Z" fill="#333333"/>\n' +
                    '<path d="M0 0H29V13.5849C29 17.3238 27.0054 20.7789 23.7676 22.6485L14.5001 28L5.23246 22.6485C1.99457 20.7789 3.32377e-06 17.3238 3.32377e-06 13.5849L0 0Z" fill="#FFDD2D"/>\n' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M8 7V11.5077C8.6164 10.8116 9.73715 10.3406 11.0186 10.3406H12.4111V15.5807C12.4111 16.9748 12.0323 18.3399 11.4703 19.0111H17.5276C16.9668 18.3392 16.5889 16.9758 16.5889 15.5834V10.3406H17.9815C19.2629 10.3406 20.3836 10.8116 21 11.5077V7H8Z" fill="#333333"/>\n' +
                    '</svg>\n',
                default: true,
                id: 'tbank',
            }
        ],

        cart: {
            items: [],
            totalQuantity: 0,
            total: 0
        }, // корзина
        buyNow: '', // товар, который покупается сейчас, проходит вне корзины
    },
    getters: {

    },
    mutations: {
        RESET_MODULE(state, payload) {
            const { moduleName } = payload;
            if (!state[moduleName]) throw new Error(`Модуль ${moduleName} не найден.`);

            function cleanStructure(obj) {
                if (Array.isArray(obj)) {
                    return obj.map(cleanStructure);
                }

                if (typeof obj === 'object' && obj !== null) {
                    let cleanedObj = {};

                    for (let key in obj) {
                        if (key === 'productFilters') {
                            cleanedObj[key] = obj[key];
                        } else {
                            cleanedObj[key] = cleanStructure(obj[key]);
                        }
                    }

                    return cleanedObj;
                }

                return null;
            }

            state[moduleName] = cleanStructure(state[moduleName]);

            window.localStorage.removeItem('vuex');
        },

        SET_PAGES(state, payload) {
            state.pages = payload;
        },

        SET_PRODUCTS(state, payload) {
            state.products = payload;
        },

        SET_ACTUAL_PRODUCT(state, payload) {
            state.actualProduct = payload;
        },

        SET_ACTUAL_USER(state, payload) {
            state.actualUser = payload;
        },

        SET_SIMILAR_PRODUCTS(state, payload) {
            state.similarProducts = payload;
        },

        SET_ORDERS(state, payload) {
            state.orders = payload;
        },

        SET_USERS(state, payload) {
            state.users = payload;
        },

        SET_PAGES_KEYS(state, payload) {
            state.pagesKeys = payload;
        },

        SET_PRODUCTS_KEYS(state, payload) {
            state.productsKeys = payload;
        },

        SET_USERS_KEYS(state, payload) {
            state.usersKeys = payload;
        },

        SET_IMAGES(state, payload) {
            state.images = payload;
        },

        SET_SIZES(state, payload) {
            state.sizes = payload;
        },

        SET_TEAMS(state, payload) {
            state.teams = payload;
        },

        SET_SEASONS(state, payload) {
            state.seasons = payload;
        },

        SET_COUNTRIES(state, payload) {
            state.countries = payload;
        },

        SET_CONDITIONS(state, payload) {
            state.conditions = payload;
        },

        SET_PRODUCT_TYPES(state, payload) {
            state.productTypes = payload;
        },

        SET_PAGE_TYPES(state, payload) {
            state.pageTypes = payload;
        },

        SET_BRANDS(state, payload) {
            state.brands = payload;
        },

        SET_COLORS(state, payload) {
            state.colors = payload;
        },

        SET_PRODUCT_COLORS(state, payload) {
            state.productColors = payload;
        },

        SET_STATUSES(state, payload) {
            state.statuses = payload;
        },

        ADD_TO_CART(state, payload) {
            let existingItemIndex = state.cart.items.findIndex(item => item["Код"] === payload.item["Код"]);
            if (existingItemIndex !== -1) {
                // Если товар уже есть в корзине, не увеличиваем количество
                state.cart.items[existingItemIndex].quantity = 1;
            } else {
                // Иначе добавляем новый элемент
                state.cart.items.push({...payload.item, quantity: payload.quantity});
                state.cart.total += payload.item["Цена по скидке"];

                if (payload.item['Код'] !== 'Shipping') {
                    state.cart.totalQuantity++;
                }
            }

            // доставка всегда последняя
            let shippingIndex = state.cart.items.findIndex(item => item["Код"] === 'Shipping');
            if (shippingIndex !== -1 && shippingIndex !== state.cart.items.length - 1) {
                let shippingItem = state.cart.items.splice(shippingIndex, 1)[0];
                state.cart.items.push(shippingItem);
            }
        },

        CALCULATE_SUM(state, payload) {
            state.cart.total = 0;

            if (payload.discount === 0) {
                for (let item of state.cart.items) {
                    item['Цена по скидке'] = item.sp || item['Цена по скидке']
                }
            }

            for (let item of state.cart.items) {
                if (payload.discount < 1) {
                    item.sp = item["Цена по скидке"]
                    item["Цена по скидке"] = item["Цена по скидке"] - item["Цена по скидке"] * payload.discount;

                    state.cart.total += item.sp - item.sp * payload.discount;
                } else {
                    item.sp = item["Цена по скидке"]
                    item["Цена по скидке"] = item["Цена по скидке"] - payload.discount;

                    state.cart.total += item.sp - payload.discount;
                }
            }

            if (state.buyNow['Код']) {
                state.cart.total = 0;

                if (payload.discount < 1) {
                    state.buyNow.sp = state.buyNow["Цена по скидке"]
                    state.buyNow["Цена по скидке"] = state.buyNow['Цена по скидке'] - state.buyNow['Цена по скидке'] * payload.discount;

                    state.cart.total += state.buyNow.sp - state.buyNow.sp * payload.discount;
                } else {
                    state.buyNow.sp = state.buyNow["Цена по скидке"]
                    state.buyNow["Цена по скидке"] = state.buyNow['Цена по скидке'] - payload.discount;

                    state.cart.total += state.buyNow.sp - payload.discount;
                }
            }

            if (payload.discount !== 0) {
                if (payload.discount < 1) {
                    state.cart.discount = payload.discount * 100 + '%';
                } else {
                    state.cart.discount = (parseInt(payload.discount) / (parseInt(payload.discount) + parseInt(state.cart.total))) * 100;

                    if (parseFloat(state.cart.discount.toFixed(1)) % 1 === 0) {
                        state.cart.discount = Math.floor(parseFloat(state.cart.discount.toFixed(1))) + '%'
                    } else {
                        state.cart.discount = parseFloat(state.cart.discount.toFixed(1)) + '%'
                    }
                }
            } else {
                state.cart.discount = null;
            }
        },

        REMOVE_FROM_CART(state, payload) {
            const updatedItems = [...state.cart.items].filter((item) => item['Код'] !== payload.item['Код']);

            state.cart.items = updatedItems;
            state.cart.totalQuantity--;
            state.cart.total -= payload.item["Цена по скидке"];

            if (state.cart.items.length === 1 && state.cart.items[0]['Код'] === 'Shipping') {
                state.cart = {
                    items: [],
                    totalQuantity: 0,
                    total: 0
                };
            }
        },

        RESET_CART(state, payload) {
            state.cart = {
                items: [],
                totalQuantity: 0,
                total: 0
            };
        },

        SET_BUY_NOW(state, payload) {
            state.buyNow = payload;
        }
    },
    actions: {
        async fetchProducts({ commit }, params) {
            try {
                let transformedData;

                const response = await axios.get(
                    `${baseUrl}/products/getProducts`,
                    {
                        params: params || {},
                        ...config
                    }
                );

                try {
                    const renameKeys = obj => {
                        return {
                            'Код': obj.code,
                            'Название продукта': obj.product_name,
                            'Обычная цена': obj.common_price,
                            'Цена по скидке': obj.sale_price,
                            'Тип продукта': obj.product_type,
                            'Размер': obj.size_name,
                            'Состояние': obj.product_condition,
                            'Дата последнего изменения': obj.date_last_change,
                            'Бренд': obj.brand,
                            'Команда': obj.team_and_country,
                            'Сезон': obj.season,
                            'Автор': obj.create_by
                        };
                    };

                    // Преобразование исходного массива
                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_PRODUCTS', transformedData); // сохраняем данные в состояние

                commit('SET_PRODUCTS_KEYS', {
                    'Название продукта': "productName",
                    'Обычная цена': "commonPrice",
                    'Цена по скидке': "salePrice",
                    "Описание": "descriptionText",
                    "Недостатки": "issuesText",
                    'Тип продукта': "typeName",
                    'Размер': "sizeName",
                    'Состояние': "conditionName",
                    'Сезон': "season",
                    'Бренд': "brandName",
                    'Команда': "teamName",
                    'Автор': "creatorEmail",
                    'Цвет': "colors"
                });
            } catch (error) {
                console.error(error);
            }
        },

        async fetchActualProduct({ commit }, params) {
            try {
                let transformedData;
                const response = await axios.get(
                    `${baseUrl}/products/getProductByCode`,
                    {
                        params: params || {},
                        ...config
                    }
                );

                try {
                    const renameKeys = obj => {
                        return {
                            'Код': obj.code,
                            'Название продукта': obj.product_name,
                            'Обычная цена': obj.common_price,
                            'Цена по скидке': obj.sale_price,
                            'Описание': obj.description,
                            'Недостатки': obj.issues_text,
                            'Дата последнего изменения': obj.date_last_change,
                            'Тип продукта': obj.product_type,
                            'Размер': obj.size_name,
                            'Состояние': obj.product_condition,
                            'Сезон': obj.season,
                            'Команда': obj.team_and_country,
                            'Бренд': obj.brand,
                            'Автор': obj.create_by
                        };
                    };

                    // Преобразование исходного массива
                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_ACTUAL_PRODUCT', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },

        async fetchSimilarProducts({ commit }, params) {
            try {
                let transformedData;
                const response = await axios.get(
                    `${baseUrl}/products/getSimilarProducts`,
                    {
                        params: params || {},
                        ...config
                    }
                );

                try {
                    const renameKeys = obj => {
                        return {
                            'Код': obj.code,
                            'Название продукта': obj.product_name,
                            'Обычная цена': obj.common_price,
                            'Цена по скидке': obj.sale_price,
                            'Описание': obj.description,
                            'Недостатки': obj.issues_text,
                            'Дата последнего изменения': obj.date_last_change,
                            'Тип продукта': obj.product_type,
                            'Размер': obj.size_name,
                            'Состояние': obj.product_condition,
                            'Сезон': obj.season,
                            'Команда': obj.team_and_country,
                            'Бренд': obj.brand,
                            'Автор': obj.create_by
                        };
                    };

                    // Преобразование исходного массива
                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_SIMILAR_PRODUCTS', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },

        async fetchImages({ commit }, params) {
            try {
                let transformedData;
                const response = await axios.get(
                    `${baseUrl}/images/getImages`,
                    {
                        params: params || {},
                        ...config
                    }
                );

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.image_id,
                            'Ссылка': obj.image_url,
                            'Тип': obj.image_type,
                            'Товар': obj.product_id,
                            'Страница': obj.page_id,
                            'Текст': obj.image_text
                        };
                    };

                    // Преобразование исходного массива
                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_IMAGES', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },

        async fetchSizes({ commit }) {
            try {
                let transformedData;
                const response = await axios.get(baseUrl + "/sizes/getProductSizes", config); // делаем запрос к API

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.size_id,
                            'Размер': obj.size_name
                        };
                    };

                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_SIZES', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },

        async fetchTeams({ commit }) {
            try {
                let transformedData;
                const response = await axios.get(baseUrl + "/teams/getTeams", config); // делаем запрос к API

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.team_id,
                            'Команда': obj.team
                        };
                    };

                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_TEAMS', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },

        async fetchCountries({ commit }) {
            try {
                let transformedData;
                const response = await axios.get(baseUrl + "/countries/getCountries", config); // делаем запрос к API

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj["_country_id"],
                            'Страна': obj["title_ru"]
                        };
                    };

                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_COUNTRIES', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },

        async fetchSeasons({ commit }) {
            try {
                let transformedData;
                const response = await axios.get(baseUrl + "/seasons/getSeasons", config); // делаем запрос к API

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.team_id,
                            'Старт': obj.start_year,
                            'Конец': obj.end_year,
                            'Сезон': obj.start_year + '/' + obj.end_year
                        };
                    };

                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_SEASONS', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },

        async fetchBrands({ commit }) {
            try {
                let transformedData;
                const response = await axios.get(baseUrl + "/brands/getBrands", config); // делаем запрос к API

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.brand_id,
                            'Бренд': obj.brand
                        };
                    };

                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_BRANDS', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },

        async fetchConditions({ commit }) {
            try {
                let transformedData;
                const response = await axios.get(baseUrl + "/conditions/getConditions", config); // делаем запрос к API

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.condition_id,
                            'Состояние': obj.condition_name,
                            'Описание': obj.condition_description
                        };
                    };

                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_CONDITIONS', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },

        async fetchColors({ commit }) {
            try {
                let transformedData;
                const response = await axios.get(baseUrl + "/colors/getColors", config); // делаем запрос к API

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.color_id,
                            'Цвет': obj.color,
                            'Код': obj.hex_code
                        };
                    };

                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_COLORS', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },

        async fetchProductColors({ commit }, params) {
            try {
                let transformedData;
                const response = await axios.get(
                    `${baseUrl}/products/getProductColors`,
                    {
                        params: params || {},
                        ...config
                    }
                );

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.product_color_id,
                            'Код': obj.product_code,
                            'Название продукта': obj.product_name,
                            'Цвет': obj.color,
                            'HEX': obj.hex_code
                        };
                    };

                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_PRODUCT_COLORS', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },

        async fetchProductTypes({ commit }) {
            try {
                let transformedData;
                const response = await axios.get(baseUrl + "/productTypes/getProductTypes", config); // делаем запрос к API

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.product_type_id,
                            'Тип продукта': obj.product_type,
                        };
                    };

                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_PRODUCT_TYPES', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },

        async fetchPageTypes({ commit }) {
            try {
                let transformedData;
                const response = await axios.get(baseUrl + "/pageTypes/getPageTypes", config); // делаем запрос к API

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.page_type_id,
                            'Тип': obj.page_type,
                        };
                    };

                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_PAGE_TYPES', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },

        async fetchStatuses({ commit }) {
            try {
                let transformedData;
                const response = await axios.get(baseUrl + "/statuses/getStatuses", config); // делаем запрос к API

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.status_id,
                            'Статус': obj.status,
                        };
                    };

                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_STATUSES', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },
    },
    plugins: [
        createPersistedState({
            storage: window.localStorage, // или sessionStorage
            paths: [
                'productTypes',
                'pageTypes',
                'colors',
                'conditions',
                'teams',
                'seasons',
                'brands',
                'colors',
                'pagesKeys',
                'ordersKeys',
                'productKeys',
                'countries',
                'paymentsKeys',
                'productFilters',
                'cart'
            ],
        })
    ],
});
